/* eslint-disable no-continue,no-multi-assign,no-restricted-syntax */
import { fromPairs } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import useLocalStorage from 'react-use/lib/useLocalStorage';
import Block from '../../components/generic/Block';
import MapContainer from '../../components/MapContainer';
import PageHeader from '../../components/PageHeader';
import { DEVICE } from '../../constants/breakpoints';
import { LS_MAP_FILTERS_OPEN } from '../../constants/localStorage';
import { useMapFilters } from '../../containers/MapFiltersProvider';
import { useOwnerInfo } from '../../containers/OwnerInfoProvider';
import useDevice from '../../utils/hooks/useDevice';
import { px } from '../../utils/px';
import MapFilters from './components/MapFilters';
import Map from './Map';

const CONTAINER_ID = 'mapbox-container';

// https://stackoverflow.com/a/8876069/3802517
const getVh = () => Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

const ZnajdzNaMapie = () => {
  const { mapFilters } = useMapFilters();
  const { wasteBins, mapPoints } = useOwnerInfo();
  const map = useRef();
  const device = useDevice();
  const isMobile = device === DEVICE.mobile;
  const [isOpen, setIsOpen] = useLocalStorage(LS_MAP_FILTERS_OPEN, !isMobile);
  const initialIsOpen = useRef(isOpen);
  const initialIsMobile = useRef(isMobile);
  const [vh, setVh] = useState(() => getVh());

  useEffect(() => {
    const handleResize = () => setVh(getVh());
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    map.current = new Map(CONTAINER_ID, initialIsOpen.current, initialIsMobile.current);
    return () => {
      map.current.remove();
      map.current = null;
    };
  }, []);

  useEffect(() => {
    if (map.current && mapPoints.length > 0) {
      map.current.setData(mapPoints);
    }
  }, [mapPoints]);

  useEffect(() => {
    if (map.current) {
      map.current.setFilters(mapFilters);
    }
  }, [mapFilters]);

  useEffect(() => {
    if (map.current) {
      map.current.setFiltersOpen(isOpen);
    }
  }, [isOpen]);

  useEffect(() => {
    if (map.current) {
      map.current.setIsMobile(isMobile);
    }
  }, [isMobile]);

  useEffect(() => {
    if (map.current) {
      const mapWasteBins = fromPairs(Object.entries(wasteBins).filter(([_, wasteBin]) => wasteBin.showOnMap));
      map.current.setMapWasteBins(mapWasteBins);
    }
  }, [map, wasteBins]);

  const height = useMemo(() => [px(Math.min(500, 0.7 * vh)), px(600)], [vh]);

  return (
    <div>
      <PageHeader>Znajdź punkt zbiórki</PageHeader>
      <Block relative height={height}>
        <MapFilters isOpen={isOpen} setIsOpen={setIsOpen} />
        <MapContainer id={CONTAINER_ID} height="100%" marginBottom={2} />
      </Block>
    </div>
  );
};

ZnajdzNaMapie.propTypes = {};

export default ZnajdzNaMapie; // lazy import
